import FeatureToggles from './FeatureToggles';

export default FeatureToggles;
